<template>
    <div class="common-page">
        <div class="discovers">
            <div class="discover reverse">
                <figure><img src="https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/public%2Fmold-1.jpg?alt=media&token=5fa66011-d9bd-4d5b-9c0a-13e46c264b64" alt=""></figure>
                <div class="discover-box">
                    <h2>Moldes em alumínio</h2>
                    <p>Os moldes em alumínio são recomendados em diversas ocasiões, principalmente quando deve-se ter alta resistência, durabilidade e qualidade na usinagem.</p>
                </div>
            </div>
            <div class="discover">
                <figure><img src="https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/public%2Fmold-3.jpg?alt=media&token=9dd77775-d094-4c9f-aa75-267419ab33cc" alt=""></figure>
                <div class="discover-box">
                    <h2>Refrigeramento</h2>
                    <p>Quando a velocidade de produção for muito alta, ou o tamanho do molde for grande e do material utilizado, a chance de moldar uma peça perfeita é cada vez menor. Neste caso, quando o molde é refrigerado, o aproveitamento é aumentado significamente. </p>
                </div>
            </div>
            <div class="discover reverse">
                <figure><img src="https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/public%2Fmold-2.jpg?alt=media&token=cac34ec7-8d6b-49e2-a0bf-15c9395dd503" alt=""></figure>
                <div class="discover-box">
                    <h2>Pronto para moldar</h2>
                    <p>Com anos de experiência em modelagem, moldagem e torneamento, nossa equipe é capaz de produzir moldes perfeitos para sua embalagem. Os moldes já vem com canais prontos para o vácuo.</p>
                </div>
            </div>
        </div>
        <get-in-touch></get-in-touch>
    </div>
</template>
<script>
import GetInTouch from '../components/GetInTouch.vue'

export default {
    name: "Molding",
    components: {
        GetInTouch
    }
}
</script>